import { css } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import { tokens } from '@hotjar/hotsauce';

import { SMART_PANEL_SPACING } from '../constants-types/Layout';

export const smartPanelElementFullWidthStyles = (): SerializedStyles => css`
  margin-left: -${SMART_PANEL_SPACING};
  margin-right: -${SMART_PANEL_SPACING};
  border-radius: 0;
  border-left: 0;
  border-right: 0;

  &:focus {
    border-color: ${tokens.color.ui_border_active};
    border-top: 2px;
    border-bottom: 2px;
    border-style: solid;
  }
`;

export const smartPanelElementFullHeightStyles = (): SerializedStyles => css`
  margin-top: -${SMART_PANEL_SPACING};
  margin-bottom: -${SMART_PANEL_SPACING};
`;

export const smartPanelAccordionBorderStyles = (): SerializedStyles => css`
  border-bottom: 4px solid ${tokens.color.ui_border_light};
`;
